<script>
import SvgId from "@/components/Svg/SvgId.vue";
export default {
  components: {
    SvgId,
  },
  computed: {
    style() {
      const primaryColor =
        this.$store.state.config?.colors?.primaryOptionColor || "#51B44F";
      return {
        "--btn-color": primaryColor,
        "--bg-color": `${primaryColor}1A`,
      };
    },
  },
};
</script>

<template>
  <button
    :style="style"
    v-on="$listeners"
    v-bind="$attrs"
    class="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4 rounded-lg p-3 sm:p-2 appearance-none select-none w-full bg-color"
    type="button"
    :aria-label="$slots.default[0].text + ' - Click to proceed'"
  >
    <span class="flex space-x-2 sm:space-x-4 flex-1 items-center">
      <svg-id class="flex-shrink-0" aria-hidden="true"></svg-id>
      <span class="text-sm text-left font-semibold"><slot></slot></span>
    </span>
    <span
      class="flex items-center justify-center w-full sm:w-auto space-x-2 text-white text-xs rounded-lg px-4 py-2 font-bold btn-color"
    >
      <span>Let's go</span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M4.1665 10H15.8332"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 4.16663L15.8333 9.99996L10 15.8333"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </button>
</template>

<style scoped>
.btn-color {
  background-color: var(--btn-color);
}
.bg-color {
  background-color: var(--bg-color);
}
</style>
